import { jsx as _jsx } from "react/jsx-runtime";
const IconRemove = () => (_jsx("svg", { className: "oc-icon oc-icon-remove", viewBox: "0 0 12 12", children: _jsx("path", { d: "M6 4l4-4 2 2-4 4 4 4-2 2-4-4-4 4-2-2 4-4-4-4 2-2 4 4z", fill: "" }) }));
export default IconRemove;
